import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LoginContainer } from './pages/Login/LoginContainer';
import { AuthProvider } from './providers/auth';
import { UserDataProvider } from './providers/userData';
import { ThemeProvider } from './providers/theme';
import { OpenProvider } from './providers/openModal';
import { LoadingProvider } from './providers/loading';
import { ContractNameProvider } from './providers/contractName';
import { PrivateRoute } from './routes/PrivateRoute';
import { ContractListContainer } from './pages/ContractList/ContractListContainer';
import { ProjectListContainer } from './pages/ProjectList/ProjectListContainer';
import { ProjectPageContainer } from './pages/ProjectPage/ProjectPageContainer';
import { ContractPageContainer } from './pages/ContractPage/ContractPageContainer';
import { ProjectFieldContainer } from './pages/ProjectField/ProjectFieldContainer';
import { AnswerRecordsContainer } from './pages/AnswerRecords/AnswerRecordsContainer';
import { AnswerPageContainer } from './pages/AnswerPage/AnswerPageContainer';

export function App() {
  return (
    <AuthProvider>
      <UserDataProvider>
        <ThemeProvider>
          <OpenProvider>
            <LoadingProvider>
              <ContractNameProvider>
                <BrowserRouter>
                  <Routes>
                    <Route path='/' element={<LoginContainer />} />
                    <Route element={<PrivateRoute />}>
                      <Route path='/contract' element={<ContractPageContainer />} />
                      <Route path='/contracts' element={<ContractListContainer />} />
                      <Route path='/contracts/:contractId/projects' element={<ProjectListContainer />} />
                      <Route path='/contracts/:contractId/project' element={<ProjectPageContainer />} />
                      <Route path='/contracts/:contractId/project/:projectId' element={<ProjectFieldContainer />} />
                      <Route path='/contracts/:contractId/project/:projectId/answers' element={<AnswerRecordsContainer />} />
                      <Route path='/contracts/:contractId/project/:projectId/answer/:answerRecordId' element={<AnswerPageContainer />} />
                    </Route>
                  </Routes>
                </BrowserRouter>
              </ContractNameProvider>
            </LoadingProvider>
          </OpenProvider>
        </ThemeProvider>
      </UserDataProvider>
    </AuthProvider >
  );
}
